import { Helmet } from 'react-helmet-async';
// sections
import HolidayCalendarCurrentYearListView from 'src/sections/holiday-calendar/HolidayCalendarCurrentYearListView';

// ----------------------------------------------------------------------

export default function HolidaySimplePage() {
    return (
        <>
            <Helmet>
                <title> Holiday Calendar </title>
            </Helmet>

            <HolidayCalendarCurrentYearListView />
        </>
    );
}
